import { lazyLoad } from 'utils/loadable';

export const UnauthorizedLoadable = lazyLoad(
  () => import('./Unauthorized'),
  module => module.Unauthorized,
);
